import utils from '../../utils';
import fetch from '../fetch';
import { Tag } from 'antd';
import React from 'react';

const DataGrid = {
    selections: [],
    selectData: [],
    refresh: function() {

    }
}

/**
 * @method setRefresh
 * @param {function} callback
 * @return {promise}
 */
const setRefresh = (callback) => {
    DataGrid.refresh = callback
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelectData = (data) => {
    DataGrid.selectData = data;
}

/**
 * @method onSelect
 * @param {array} ids [id: int, ...]
 * @return {promise}
 */
const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}


const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    let params = []
    if (keywords['sort'] != '$index') {
        for(var i in keywords) {
            if(i === 'order') {
                params.push(`order=${keywords[i]}`)
            }
            if(i === 'sort') {
                params.push(`sort=${keywords[i]}`)
            }
        }
    }
    params.push(`pageNum=${keywords.pageNum}`)
    params.push(`pageSize=${keywords.pageSize}`)
    return fetch.post('reverseEval/query?' + params.join('&'), keywords)
    .then((response) => {
        if(response.code == 200) {
            const columns = [
                {
                    key: '$index', 
                    label: '序号'
                },
                {
                    key: 'employeeName',
                    label: '教师'
                },
                {
                    key: 'employeeCode',
                    label: '工号'
                },
                {
                    key: 'needCount',
                    label: '应评次数'
                },
                {
                    key: 'evalCount',
                    label: '已评次数',
                },
                {
                    key: 'needPersonCount',
                    label: '应评人数',
                },
                {
                    key: 'evalPersonCount',
                    label: '已评人数',
                },
                {
                    key: 'status',
                    label: '是否完成',
                    render: (v) => {
                        if (v === 1) {
                            return <Tag>未完成</Tag>
                        } else if (v === 2) {
                            return <Tag color="#108ee9">已完成</Tag>
                        }
                    },
                    width: 80
                },
                {
                    key: 'termName',
                    label: '学期',
                    width: 160
                }
            ]
            return {
                headers : utils.columns(columns),
                data: response.payload.data,
            }
        }
    }).then(res => (
        Object.assign({
            headers: res.headers,
            result: res.data.dataList || [],
            selects: (res.data.dataList || []).map(d => ({
                value: d.id,
                checked: false,
            })),
            checked: false,
            total: res.data.total,
            pageIndex: res.data.pageNum,
            pageSize: res.data.pageSize,
            notify: (res.data || []).length ? '' : '暂无数据...'
        }))
    )
}

export default {
    setRefresh,
    onSelectData,
    onSelect,
    getSelection,
    querySearch,
}